import React from 'react';
import { PropTypes } from 'prop-types';
import { useQuery } from '@apollo/client';
import { FUNCTIONAL_TITLE_GRAPHQL } from '@general/graphql/functional-title.graph';

const useFunctionalTitles = () => useQuery(FUNCTIONAL_TITLE_GRAPHQL);

useFunctionalTitles.propTypes = {};

export default useFunctionalTitles;
